import React, { useState, useEffect, useCallback } from "react";
import _ from 'lodash';
import {
  Container, Label, Button, FormGroup,
  Modal, ModalHeader, ModalBody, ModalFooter, Input,
} from "reactstrap";
import {
  Row,
  Col,
  Table,
} from "reactstrap";
import ApiCaller from "../../api/apiCaller";
import CustomDropdownInput from "../../components/CustomDropdownInput";
import t from "utils/Lang";
import "./index.css";

interface SelectCityInputProps {
  onSelect?: (buildingLocationId:number) => void,
  city?: any;
  district?: any;
  ward?: any;
  isView?: boolean;
  elementToShow?: any;
}

const CityPicker = ({ onSelect, city, district, ward, isView, elementToShow }:SelectCityInputProps) => {

  const [selectedData, setSelectedData] = useState<any>({});

  const [cityOptions, setCityOptions] = useState<Array<any>>([]);
  const [districtOptions, setDistrictOptions] = useState<Array<any>>([]);
  const [wardOptions, setWardOptions] = useState<Array<any>>([]);

  const [selectedCityId, setSelectedCityId] = useState<number | null>(null);
  const [selectedDistrictId, setSelectedDistrictId] = useState<number | null>(null);
  const [selectedWardId, setSelectedWardId] = useState<number | null>(null);

  /* Load district, city and ward */
  const getCityOptions = async () => {
    const results:Array<any> = [];
    const res = await ApiCaller.get(
      `city/`
    );
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        results.push({
          value: item.id,
          label: item.name,
        });
      });
      setCityOptions(results);
      if (city) {
        setSelectedData({
          ...selectedData,
          city: {
            id: city.id,
            name: city.name,
          },
        });
        setSelectedCityId(city.id);
      }
    }
  }
  const getDistrictOptions = async () => {
    const results:Array<any> = [];
    let districtFilterString = `(col:city,opr:rel_o_m,value:${selectedCityId})`;
    const res = await ApiCaller.get(
      `district/?q=(filters:!(${districtFilterString}))`
    );
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        results.push({
          value: item.id,
          label: item.name,
        });
      });
      setDistrictOptions(results);
      if (district) {
        setSelectedData({
          ...selectedData,
          district: {
            id: district.id,
            name: district.name,
          },
        });
        setSelectedDistrictId(district.id);
      }
    }
  }
  const getWardOptions = async () => {
    const results:Array<any> = [];
    let wardFilterString = `(col:district,opr:rel_o_m,value:${selectedDistrictId})`;
    const res = await ApiCaller.get(
      `ward/?q=(filters:!(${wardFilterString}))`
    );
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        results.push({
          value: item.id,
          label: item.name,
        });
      });
      setWardOptions(results);
      if (ward) {
        setSelectedData({
          ...selectedData,
          ward: {
            id: ward.id,
            name: ward.name,
          },
        });
        setSelectedWardId(ward.id);
      }
    }
  }

  const updateAttr = (attributeName: string, selectedOption: any) => {
    const newSelectedData = selectedData;
    const selectedOptionTransformed = {
      id: selectedOption.value,
      name: selectedOption.label,
    }
    newSelectedData[attributeName] = selectedOptionTransformed;
    setSelectedData(newSelectedData);

    if (attributeName === 'city') setSelectedCityId(selectedOption.value);
    if (attributeName === 'district') setSelectedDistrictId(selectedOption.value);
    if (attributeName === 'ward') setSelectedWardId(selectedOption.value);

    if (onSelect) {
      onSelect(newSelectedData);
    }
  }

  useEffect(() => {
    getCityOptions();
  }, [city, district, ward]);

  useEffect(() => {
    if (selectedCityId !== null) {
      getDistrictOptions();
    }
  }, [selectedCityId]);

  useEffect(() => {
    if (selectedDistrictId !== null) {
      getWardOptions();
    }
  }, [selectedDistrictId]);

  return (
    <Row>
      {!elementToShow || (elementToShow && elementToShow.includes('city')) &&
        <Col xs={12} sm={6}>
          <CustomDropdownInput
            disabled={isView}
            callback={updateAttr}
            data={selectedData}
            options={cityOptions}
            labelText={t().city_picker__city}
            attributeName="city"
          />
        </Col>
      }
      {!elementToShow || (elementToShow && elementToShow.includes('district')) &&
        <Col xs={12} sm={6}>
          <CustomDropdownInput
            disabled={isView}
            callback={updateAttr}
            data={selectedData}
            options={districtOptions}
            labelText={t().city_picker__district}
            attributeName="district"
          />
        </Col>
      }
      {!elementToShow || (elementToShow && elementToShow.includes('ward')) &&
        <Col xs={12} sm={6}>
          <CustomDropdownInput
            disabled={isView}
            callback={updateAttr}
            data={selectedData}
            options={wardOptions}
            labelText={t().city_picker__ward}
            attributeName="ward"
          />
        </Col>
      }
    </Row>
  )
}

export default CityPicker;